/**
 * 커미션 구매(예매) 관련 Write — `/api/ticket` 과 동일한 엔드포인트 형태의 `/api/purchase`
 *
 * - createReservation() - 구매 신청
 * - updateReservationStatus() - 상태 변경
 * - confirmPayment() - 입금 확인
 * - deleteReservation() - 구매 삭제
 * - savePurchaseForm() - 구매 폼 저장/업데이트
 */

import apiClient from "@/utils/api";

/**
 * 구매 신청
 * @param {Object} reservationData - 구매 데이터 (스키마는 티켓 예매와 동일)
 * @returns {Promise<string>} 생성된 구매 ID
 */
export async function createReservation(reservationData) {
  try {
    const response = await apiClient.post("/api/purchase", reservationData);
    return response.data.id;
  } catch (error) {
    console.error("구매 신청 오류:", error);
    throw error;
  }
}

/**
 * 구매 상태 변경
 * @param {string} reservationId
 * @param {string} status
 */
export async function updateReservationStatus(reservationId, status) {
  try {
    await apiClient.patch(`/api/purchase/${reservationId}/status`, { status });
  } catch (error) {
    console.error("구매 상태 변경 오류:", error);
    throw error;
  }
}

/**
 * 입금 확인
 * @param {string} reservationId
 * @param {boolean} confirmed
 */
export async function confirmPayment(reservationId, confirmed) {
  try {
    await apiClient.patch(`/api/purchase/${reservationId}/payment`, { confirmed });
  } catch (error) {
    console.error("입금 확인 오류:", error);
    throw error;
  }
}

/**
 * 구매 삭제
 * @param {string} reservationId
 */
export async function deleteReservation(reservationId) {
  try {
    await apiClient.delete(`/api/purchase/${reservationId}`);
  } catch (error) {
    console.error("구매 삭제 오류:", error);
    throw error;
  }
}

/**
 * 구매 폼 저장/업데이트
 * @param {string} parentId - 커미션 문서 ID
 * @param {Object} formData
 */
export async function savePurchaseForm(parentId, formData) {
  try {
    await apiClient.post(`/api/purchase/form/${parentId}`, formData);
  } catch (error) {
    console.error("구매 폼 저장 오류:", error);
    throw error;
  }
}
